<template>
    <div class="pages" :class="classObj">
        <div class="user_info">
            <div class="user_box" @click="toMyProfile">
                <img src="@/assets/person/avatar.png">
                <div>
                    <div class="phone">Hi,{{ userPhone }}</div>
                    <div @click.stop="copyText(userInfo.id)">
                        ID: {{ userInfo.id }}
                        <i class="iconfont icon-fuzhi"></i>
                    </div>
                </div>
                <div class="icon_logout" @click.stop="handleLogout">
                    <img src="@/assets/person/icon_logout.png" />
                </div>
            </div>
            <div class="vip_box" v-if="userInfo && vipList.length" @click="toVIP">
                <div class="next-vip">{{ $t("person.VIPNeed") }}{{ nextVipItem.memberLevelCode || 0 }}</div>
                <div class="vip_img">
                    <img :src="userInfo.levelDetailVo.memberLevelIcon" alt="">
                    <div class="vip_level">
                        VIP {{ userInfo.levelDetailVo.memberLevelCode || 0 }}
                    </div>
                </div>
                <div class="vip_info">
                    <div class="vip_progress">
                        <div class="rate">{{ $t('Vip.RechargeAmount') }}: <span>{{ formatAmount(userInfo.levelDetailVo.currentAmtRecharge ||
                            0) }}/{{ formatAmount(nextVipItem.amtRecharge || 0) }}</span></div>
                        <lineProgress :progress="userInfo.rechargeProgress" :height="0.18"></lineProgress>
                        <div class="rate">{{ $t('Vip.BetAmount') }}: <span>{{ formatAmount(userInfo.levelDetailVo.currentAmtOrder || 0
                        ) }}/{{ formatAmount(nextVipItem.amtOrder || 0) }}</span></div>
                        <lineProgress :progress="userInfo.betProgress" :height="0.18"></lineProgress>
                    </div>
                </div>
            </div>
            <div class="money_box">
                <div class="header">{{ $t("person.AccountTotal") }}</div>
                <div class="money_wrap">
                    <div>
                        <div class="money"> {{ formatAmount(allBalance, 2) }} </div>
                        <div> {{ $t('depositWithdraw.TotalBalance') }} </div>
                    </div>
                    <div>
                        <div class="money"> {{ formatAmount(rate > 0 || orderWater == 0 ? 0 : useBalance, 2) }} </div>
                        <div> {{ $t('depositWithdraw.WithdrawableAmount') }} </div>
                    </div>
                </div>
                <div class="func_btns">
                    <div id="person-deposit-btn" @click="toDeposit">
                        {{ $t("deposit.Deposit") }}
                    </div>
                    <div id="person-withdraw-btn" @click="toWithdraw">
                        {{ $t("Withdraw.Withdraw") }}
                    </div>
                </div>
            </div>
            <div class="contaItem" @click.stop="toShare">
                <div class="contaTitleLine">
                    {{ $t("share.PromotedAccount") }}
                </div>
                <div class="spreadLine">
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allGrandTotalDirectFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">{{ $t("share.TotalPrize") }}</div>
                    </div>
                    <div class="line"></div>
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allUnDistributionFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">
                            {{ $t("share.BonusPendingSettlement") }}
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="spreadList">
                        <div v-if="invitationPageRewardState === 'enable'" class="spreadAmount">{{ formatCurrency(shareData.allDistributionFirstAmt || 0) }}</div>
                        <div v-else>{{ CurrencyType }}0</div>
                        <div class="spreadName">{{ $t("share.BonusesAlreadySettled") }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="menus">
            <div class="menus-item" @click.stop="$refs.RedemptionRecordPopup.open()">
                <span class="text">{{ $t("RedemptionCode.RedemptionRecord") }}</span>
            </div>
            <div v-if="invitationPageRewardState === 'enable'" class="menus-item" @click.stop="toTransaction">
                <span class="text">{{ $t("person.Transaction") }}</span>
            </div>
            <div class="menus-item" @click.stop="toBetHistory">
                <span class="text">{{ $t("person.History") }}</span>
            </div>
            <div class="menus-item" @click="toSetting">
                <span class="text">{{ $t("person.AccountSettings") }}</span>
            </div>
            <div class="menus-item" @click="$refs.lang.onShowLangPopup()">
                <span class="text"> {{ langType }}</span>
                <div class="language_box">
                    <language ref="lang" :show="true" :showIcon="false"></language>
                </div>
            </div>
            <div class="menus-item" @click="toNotification">
                <span class="text">{{ $t("person.LiveChat") }}</span>
            </div>
            <div class="menus-item" @click="onShowDownAppPopup">
                <span class="text">{{ $t("person.Install") }}</span>
            </div>
        </div>
        <div class="logout" @click="handleLogout">
            {{ $t("logout.SignOut") }}
        </div>
        <loginPopup @loginSucc="init"></loginPopup>
        <logoutPopup ref="logoutPopup" ></logoutPopup>
        <notification ref="notification"></notification>
        <!-- <BonusTransferPopup ref="BonusTransferPopup" @confirm="init"></BonusTransferPopup> -->
        <RedemptionRecordPopup ref="RedemptionRecordPopup"></RedemptionRecordPopup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { Toast } from 'vant'
import lineProgress from '@/components/lineProgress'
import handleCopy from '@/utils/copy.js'
import logoutPopup from '@/components/logoutPopup'
import notification from '@/components/notification'
import RedemptionRecordPopup from '@/components/RedemptionCodePopup/modules/RedemptionRecordPopup.vue'
// import BonusTransferPopup from '@/components/BonusTransferPopup'
import language from '@/components/language'
import {
    getListLevel,
    getUserInfo
} from '@/api/user'
import { getShareinfo } from '@/api/share'
import {
    domainName
} from '@/common/http/index.js'
export default {
    name: 'Person',
    components: { lineProgress, logoutPopup, notification, language, RedemptionRecordPopup },
    computed: {
        isLogin() {
            return !!this.$store.getters.token
        },
        userPhone() {
            const phone = this.userInfo && this.userInfo.phone
            return phone ? this.maskNumber(phone) : ''
        },
        // userMoney() {
        //     // const userInfo = this.$store.getters.userInfo
        //     const info = {
        //         balanceAmtAccount: this.allBalance
        //         // bonusAmtAccount: userInfo.balanceAmtAccount ? userInfo.bonusAmtAccount.useBalance.toFixed(2) : '0.0'
        //     }
        //     return info
        // },
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        sysConfig() {
            return this.$store.getters.sysConfig
        },
        langType() {
            return this.langObj[this.$store.getters.language].name || 'English'
        },
        invitationPageRewardState() {
            return this.$store.getters.userInfo && this.$store.getters.userInfo.invitationPageRewardState
        }
    },
    data() {
        return {
            domainName: '',
            vipList: [],
            userInfo: {
                levelDetailVo: {
                    memberLevelIcon: '',
                    currentAmtRecharge: 0,
                    currentAmtOrder: 0,
                    memberLevelCode: 0
                }
            },
            rate: 0,
            orderWater: 0,
            nextVipItem: {},
            shareData: {}
        }
    },
    created() {
        this.domainName = domainName
    },
    activated() {
        const that = this
        if (!that.classObj.mobile) that.getShareInfo(true)
        that.getUserInfo().then(() => {
            that.getListLevel(true)
        })
    },
    methods: {
        init() {
            const that = this
            if (!that.classObj.mobile) that.getShareInfo(true)
            that.getUserInfo().then(() => {
                that.getListLevel(true)
            })
        },
        getUserInfo() {
            return new Promise((resolve, reject) => {
                getUserInfo().then((res) => {
                    const {
                        result,
                        code
                    } = res
                    if (code === 0) {
                        const D1 = result
                        this.userInfo = result
                        this.userInfo.levelDetailVo.currentAmtRecharge = result.levelDetailVo.currentAmtRecharge
                        this.userInfo.levelDetailVo.currentAmtOrder = result.levelDetailVo.currentAmtOrder
                        this.userInfo.levelDetailVo.memberLevelCode = result.levelDetailVo.memberLevelCode
                        const rate = ((D1.turnoverLimit || 0) - (D1.orderWater || 0)).toFixed(2)
                        this.rate = rate > 0 ? rate : 0
                        this.orderWater = D1.orderWater
                        resolve(result)
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },
        getListLevel(isNoLoading) {
            const that = this
            getListLevel({}, isNoLoading).then((res) => {
                that.vipList = res.result
            }).then(() => {
                this.handleVipData()
            })
        },
        getShareInfo(isNoLoading) {
            getShareinfo({}, isNoLoading).then((res) => {
                if (res?.code) return
                const D = res?.result
                this.shareData = D
            })
        },
        handleVipData() {
            const that = this
            if (that.vipList.length && that.userInfo) {
                const nextLevel = that.userInfo.levelDetailVo.memberLevelCode + 1
                that.nextVipItem = that.vipList[nextLevel] || that.vipList[that.vipList.length - 1]
                that.userInfo.rechargeProgress = (that.userInfo.levelDetailVo.currentAmtRecharge / that.nextVipItem.amtRecharge) * 100
                that.userInfo.betProgress = (that.userInfo.levelDetailVo.currentAmtOrder / that.nextVipItem.amtOrder) * 100
                if (that.userInfo.rechargeProgress > 100) {
                    that.userInfo.rechargeProgress = 100
                }
                if (that.userInfo.betProgress > 100) {
                    that.userInfo.betProgress = 100
                }
                if (that.userInfo.levelDetailVo.currentAmtRecharge === 0) {
                    that.userInfo.rechargeProgress = 0
                }
                if (that.userInfo.levelDetailVo.currentAmtOrder === 0) {
                    that.userInfo.betProgress = 0
                }
                that.userInfo.rechargeDistance = that.nextVipItem.amtRecharge - that.userInfo.levelDetailVo.currentAmtRecharge
                that.userInfo.betDistance = that.nextVipItem.amtOrder - that.userInfo.levelDetailVo.currentAmtOrder
                // console.log(that.userInfo.levelDetailVo.currentAmtRecharge, that.userInfo.levelDetailVo.currentAmtOrder)
                // console.log(that.userInfo.rechargeProgress, that.userInfo.betProgress)
            }
        },
        maskNumber(phoneNumber) {
            const str = phoneNumber.toString()
            if (str.length <= 4) {
                return str
            }
            const firstTwo = str.slice(0, 2)
            const lastTwo = str.slice(-2)
            return `${firstTwo}***${lastTwo}`
        },
        copyText(content) {
            handleCopy(
                {
                    content,
                    success: (msg) => {
                        Toast(msg)
                    },
                    error: (msg) => {
                        Toast(msg)
                    }
                },
                this
            )
        },
        handleLogout() {
            this.$refs.logoutPopup.open()
        },
        toLogin(type) {
            this.$store.dispatch('user/changeLoginType', type)
            this.$store.dispatch('user/setIsShowLoginPopup', true)
        },
        toDeposit() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            if (this.$route.path.indexOf('/wallet?type=deposit') !== -1) {
                return
            }
            const params = { type: 'deposit' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toWithdraw() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            if (this.$route.path.indexOf('/wallet?type=Withdraw') !== -1) {
                return
            }
            const params = { type: 'Withdraw' }
            this.onNavTo({ url: '/wallet', type: 'get', params })
        },
        toMyProfile() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowMyProfilePopup', true)
        },
        toBetHistory() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowBetHistoryPopup', true)
        },
        toTransaction() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.$store.dispatch('user/setIsShowTransactionPopup', true)
        },
        toVIP() {
            if (this.$route.path.indexOf('/vip') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavToByIsLogin({ url: 'vip' })
        },
        toSetting() {
            if (this.$route.path.indexOf('/setting') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/setting' })
        },
        onShowDownAppPopup() {
            this.$store.dispatch('user/setIsShowDownAppPopup', true)
        },
        toShare() {
            if (this.$route.path.indexOf('/affiliate') !== -1) {
                this.$store.dispatch('user/setIsShowMyPopup', false)
                return
            }
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/affiliate' })
        },
        toNotification() {
            this.$store.dispatch('user/setIsShowMyPopup', false)
            this.onNavTo({ url: '/notification' })
        }
    },
    watch: {
        classObj(newVal) {
            if (!newVal.mobile) {
                this.onPageRefresh()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/common/styles/viriables.scss';

.pages {
    width: 100%;
    height: 100%;
    background:
        radial-gradient(circle at top center, rgba(96, 154, 255, 0.18) 0%, rgba(96, 154, 255, 0) 42%),
        linear-gradient(180deg, rgba(10, 34, 69, 0.99) 0%, rgba(6, 22, 44, 1) 100%);
    padding: .2rem .3rem .3rem;
    text-align: left;

    &.mobile{
        background:
            radial-gradient(circle at top center, rgba(96, 154, 255, 0.18) 0%, rgba(96, 154, 255, 0) 42%),
            linear-gradient(180deg, rgba(10, 34, 69, 0.99) 0%, rgba(6, 22, 44, 1) 100%) !important;

        .contaItem{
            display: none;
        }

        .money_box{
            padding: 0 !important;
            background: transparent !important;
            border: 0 !important;
            box-shadow: none !important;
            .header{
                display: none !important;
            }
            .money_wrap{
                display: none;
            }

            .func_btns{
                margin: 0 !important;
                & > div{
                    border-radius: .15rem;
                    text-align: center;
                    border-color: rgba(255,255,0, .24) !important;
                    height: 1.2rem;
                    background-image: none !important;
                    box-shadow: inset 0 1px 0 rgba(243, 252, 255, .22), 0 .08rem .16rem rgba(4, 16, 34, .18) !important;
                }
                & > div:first-child{
                    background:
                        radial-gradient(circle at 22% 0, rgba(131, 123, 255, .24) 0, rgba(131, 123, 255, 0) 38%),
                        linear-gradient(180deg, rgba(243, 252, 255, .22) 0%, rgba(243, 252, 255, .08) 24%, rgba(243, 252, 255, 0) 25%),
                        linear-gradient(90deg, rgb(255 199 83) 0%, rgb(255 140 41 / 99%) 42%, rgb(240 164 22 / 96%) 100%) !important;
                    color: #f8fcff !important;
                }
                & > div:last-child{
                    background:
                        radial-gradient(circle at 18% 0, rgba(118, 140, 255, .16) 0, rgba(118, 140, 255, 0) 34%),
                        linear-gradient(180deg, rgba(239, 251, 255, .18) 0%, rgba(239, 251, 255, .06) 24%, rgba(239, 251, 255, 0) 25%),
                        linear-gradient(90deg, rgba(24, 105, 206, .92) 0%, rgba(14, 74, 153, .94) 48%, rgba(8, 39, 82, .96) 100%) !important;
                    color: #f5fbff !important;
                }
            }
        }
    }

    .user_info {
        position: relative;

        .user_box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            margin-bottom: .2rem;
            padding: .16rem .22rem;
            border: 1px solid rgba(255,255,0, .24) !important;
            border-radius: .24rem;
            background:
                linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
            box-shadow: inset 0 1px 0 rgba(232, 248, 255, .08), 0 .08rem .18rem rgba(4, 16, 34, .16) !important;

            .icon_logout {
                width: .98rem;
                height: .58rem;
                background: linear-gradient(180deg, #a8161a 0%, #6f0b10 100%);
                border: 1px solid rgba(223, 172, 85, 0.28);
                box-shadow: inset 0 1px 0 rgba(255, 232, 177, 0.14);
                border-radius: .32rem;
                position: relative;
                right: auto;
                top: auto;
                transform: none;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                flex: none;

                &>img {
                    height: .34rem;
                    width: .34rem;
                    vertical-align: middle;
                    filter: brightness(1.2) sepia(.18);
                }
            }

            >img {
                width: 1.2rem;
                height: 1.2rem;
                border-radius: 50%;
                border: .04rem solid rgba(234, 196, 108, 0.48);
                box-shadow: 0 0 0 .02rem rgba(86, 26, 8, 0.32);
                margin-right: .2rem;
            }

            >div {
                flex: 1;
                min-width: 0;
                padding-right: .16rem;
                display: flex;
                flex-direction: column;
                justify-content: center;

                >div {
                    &:first-child {
                        height: .34rem;
                        line-height: .34rem;
                        color: #fff5dc;
                        font-size: .32rem;
                        margin-bottom: .12rem;
                        font-weight: 700;
                        text-shadow: 0 1px 2px rgba(52, 10, 4, 0.35);
                    }

                    &:last-child {
                        height: .3rem;
                        line-height: .3rem;
                        color: #d8bc8a;
                        font-size: .24rem;
                        display: flex;
                        align-items: center;
                        gap: .06rem;

                        i {
                            cursor: pointer;
                            color: #f1d68d;
                        }
                    }
                }
            }
        }

        .vip_box {
            display: flex;
            align-items: center;
            background: linear-gradient(180deg, rgba(111, 11, 16, 0.96) 0%, rgba(79, 6, 10, 0.98) 100%);
            border: 1px solid rgba(224, 179, 86, 0.26);
            border-radius: 10px;
            margin-bottom: 12px;
            cursor: pointer;
            overflow: hidden;
            position: relative;
            padding: 28px 20px 20px;
            column-gap: .18rem;

            .next-vip {
                position: absolute;
                top: 0;
                right: 0;
                background: linear-gradient(90deg, transparent, rgba(224, 179, 86, 0.7));
                border-radius: 0 .16rem 0 0;
                font-size: .2rem;
                padding: .02rem .2rem .04rem .6rem;
                color: #fff;
            }

            .vip_img {
                width: 1.46rem;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                flex: none;

                img {
                    width: 1.16rem;
                    height: .9rem;
                    vertical-align: middle;
                    object-fit: contain;
                    margin-bottom: .06rem;
                }

                .vip_level {
                    text-align: center;
                    font-size: .29rem;
                    font-weight: 800;
                    color: #f6d98d;
                    font-style: italic;
                    line-height: 1;
                }
            }

            .vip_info {
                flex: 1;
                display: flex;
                align-items: flex-start;
                margin: 0;
                padding-top: .02rem;

                .vip_progress {
                    flex: 1;
                    padding-right: .04rem;

                    &:last-child {
                        color: $font-sub-color;
                        font-size: .2rem;

                        .rate {
                            font-size: .26rem;
                            color: #fff;
                            margin: .02rem 0 .08rem;
                            line-height: 1.15;

                            &>span {
                                color: #e1ff00;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
        }

        .func_btns {
            margin: .3rem .4rem .32rem;
            display: flex;
            justify-content: space-between;
            gap: .16rem;

            >div {
                height: .74rem;
                width: calc(50% - .08rem);
                display: flex;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                font-size: .28rem;
                border-radius: .18rem;
                font-weight: bold;
                cursor: pointer;
                background: linear-gradient(180deg, rgba(125, 18, 24, 0.98) 0%, rgba(94, 11, 15, 0.98) 100%);
                border: 1px solid rgba(205, 137, 61, .18);
                box-shadow: inset 0 1px 0 rgba(255, 227, 180, .06);

                &:first-child {
                    background: linear-gradient(180deg, #ffe8a6 0%, #d59b32 100%);
                    color: #6a1e07;
                    border-color: rgba(255, 225, 160, .34);
                    box-shadow: inset 0 1px 0 rgba(255, 247, 212, .4), 0 .06rem .14rem rgba(89, 34, 7, .16);
                }
            }
        }

        .money_box {
            width: 100%;
            background: linear-gradient(180deg, rgba(111, 11, 16, 0.96) 0%, rgba(79, 6, 10, 0.98) 100%);
            border: 1px solid rgba(224, 179, 86, 0.26);
            border-radius: .2rem;
            overflow: hidden;
            margin-bottom: .2rem;

            .header {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: .88rem;
                font-size: .25rem;
                color: #fff;
                padding-left: .4rem;
            }

            .money_wrap {
                text-align: center;
                padding-top: .08rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &>div{
                    width: 50%;
                }
                &>div>div:first-child {
                    color: #fff;
                    font-size: .34rem;
                    line-height: 1.12;
                    font-weight: 700;
                    letter-spacing: .01rem;
                }

                &>div>div:last-child {
                    color: #e7c789;
                    font-size: .22rem;
                    margin-top: .07rem;
                }
            }
        }

        .contaItem {
            width: 100%;
            background: linear-gradient(180deg, rgba(111, 11, 16, 0.96) 0%, rgba(79, 6, 10, 0.98) 100%);
            border: .01rem solid rgba(224, 179, 86, 0.26);
            border-radius: .2rem;
            padding-bottom: .2rem;

            .contaTitleLine {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: .88rem;
                font-size: .25rem;
                color: #fff;
                padding-left: .4rem;
                cursor: pointer;
                position: relative;

                &:after {
                    content: '';
                    width: .15rem;
                    height: .15rem;
                    border-top: .01rem solid #f1f1f1;
                    border-right: .01rem solid #f1f1f1;
                    position: absolute;
                    right: .4rem;
                    top: 50%;
                    transform: rotate(45deg) translateY(-50%);
                }
            }

            .spreadLine {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .spreadList {
                    text-align: center;
                    flex: 0 1 100%;
                    width: 33.3%;
                    color: #fff;
                    font-size: .28rem;
                }

                .spreadName {
                    font-size: .24rem;
                    line-height: normal;
                    height: .5rem;
                    line-height: .25rem;
                    display: flex;
                    justify-content: center;
                    color: #e7c789;
                    white-space: pre-wrap;
                    text-align: center;
                }
            }

            .line {
                width: 1px;
                height: .7rem;
                background: rgba(255, 255, 255, .1);
            }
        }
    }

    .menus {
        width: 100%;
        margin: .2rem 0;
        padding: .2rem;
        border-radius: .2rem;
        color: #ffeed2;
        font-size: .28rem;
        background: linear-gradient(180deg, rgba(111, 11, 16, 0.96) 0%, rgba(79, 6, 10, 0.98) 100%);
        border: 1px solid rgba(224, 179, 86, 0.26);

        .menus-item {
            // padding: 0 .42rem;
            height: .88rem;
            line-height: .88rem;
            text-align: left;
            color: #ffffff;
            position: relative;
            padding-left: .2rem;
            border-bottom: 1px solid rgba(224, 179, 86, 0.2);
            cursor: pointer;

            &:last-child {
                border-bottom: 0;
            }

            &>i {
                font-size: .44rem;
                vertical-align: middle;
                margin-right: .2rem;
                color: $font-sub-color;
            }

            .language_box {
                position: absolute;
                top: -1rem;
                right: 0;
            }

            &:after {
                content: '';
                width: .17rem;
                height: .17rem;
                border-top: .02rem solid #f1f1f1;
                border-right: .02rem solid #f1f1f1;
                position: absolute;
                right: .4rem;
                top: 50%;
                transform: rotate(45deg) translateY(-50%);
            }
        }
    }

    .logout {
        color: $font-sub-color;
        margin: .3rem auto .6rem;
        font-size: .24rem;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
    }
    .vip_box,
    .money_box,
    .contaItem,
    .menus {
        background:
            linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%);
        border-color: rgba(255,255,0, .28);
        box-shadow: inset 0 1px 0 rgba(232, 248, 255, .1), 0 .08rem .18rem rgba(4, 16, 34, .18);
    }

    .vip_box .next-vip {
        background: linear-gradient(90deg, transparent, rgba(255, 177, 76, .86));
    }

    .vip_box .vip_img .vip_level,
    .vip_box .vip_info .vip_progress:last-child .rate > span {
        color: #ffe38f;
    }

    .money_box .money_wrap > div:last-child,
    .contaItem .spreadLine .spreadName {
        color: #fffae1;
    }

    .func_btns > div {
        background:
            linear-gradient(180deg, rgba(239, 251, 255, .18) 0%, rgba(239, 251, 255, .06) 24%, rgba(239, 251, 255, 0) 25%),
            linear-gradient(90deg, rgba(24, 105, 206, .92) 0%, rgba(14, 74, 153, .94) 48%, rgba(8, 39, 82, .96) 100%);
        color: #f5fbff;
        box-shadow: inset 0 1px 0 rgba(239, 251, 255, .18), inset 0 -.05rem .12rem rgba(6, 26, 58, .18);
    }

    .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba(243, 252, 255, .24) 0%, rgba(243, 252, 255, .08) 26%, rgba(243, 252, 255, 0) 27%),
            linear-gradient(90deg, rgb(255 199 83) 0%, rgb(255 140 41 / 99%) 42%, rgb(240 164 22 / 96%) 100%);
        color: #f8fcff;
        box-shadow: inset 0 1px 0 rgba(243, 252, 255, .3), inset 0 -.05rem .12rem rgba(8, 46, 96, .18);
    }

    .func_btns > div:last-child {
        border: 1px solid rgba(120, 210, 255, .22);
    }

    .menus {
        color: #fffae1;
    }

    .menus .menus-item {
        border-bottom-color: rgba(120, 210, 255, .16);
    }

    .user_info {
        background: linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
        box-shadow: inset 0 1px 0 rgba(232, 248, 255, 0.08) !important;

        .icon_logout {
            background:
                linear-gradient(180deg, rgba(239, 251, 255, .18) 0%, rgba(239, 251, 255, .06) 24%, rgba(239, 251, 255, 0) 25%),
                linear-gradient(90deg, rgba(24, 105, 206, .92) 0%, rgba(14, 74, 153, .94) 48%, rgba(8, 39, 82, .96) 100%) !important;
            border: 1px solid rgba(255,255,0, .24) !important;
            box-shadow: inset 0 1px 0 rgba(239, 251, 255, .14), 0 .05rem .12rem rgba(4, 16, 34, .12) !important;
        }
    }

    .vip_box,
    .money_box,
    .contaItem,
    .menus,
    .pages .vip_box,
    .pages .money_box,
    .pages .contaItem,
    .pages .menus {
        background:
            linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
        border-color: rgba(255,255,0, .28) !important;
        box-shadow: inset 0 1px 0 rgba(232, 248, 255, .1), 0 .08rem .18rem rgba(4, 16, 34, .18) !important;
    }

    .pages .money_box .header,
    .pages .contaItem .contaTitleLine,
    .pages .menus .menus-item,
    .pages .money_box .money_wrap > div:first-child,
    .pages .vip_box .vip_info .vip_progress:last-child .rate {
        color: #ffffff !important;
    }

    .pages .money_box .money_wrap > div:last-child,
    .pages .contaItem .spreadLine .spreadName,
    .pages .menus {
        color: #fffae1 !important;
    }

    .pages .contaItem .line,
    .pages .menus .menus-item {
        border-bottom-color: rgba(120, 210, 255, .16) !important;
    }

    .pages .func_btns > div {
        background:
            linear-gradient(180deg, rgba(239, 251, 255, .18) 0%, rgba(239, 251, 255, .06) 24%, rgba(239, 251, 255, 0) 25%),
            linear-gradient(90deg, rgba(24, 105, 206, .92) 0%, rgba(14, 74, 153, .94) 48%, rgba(8, 39, 82, .96) 100%) !important;
        color: #f5fbff !important;
        border-color: rgba(120, 210, 255, .22) !important;
        box-shadow: inset 0 1px 0 rgba(239, 251, 255, .18), inset 0 -.05rem .12rem rgba(6, 26, 58, .18) !important;
    }

    .pages .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba(243, 252, 255, .24) 0%, rgba(243, 252, 255, .08) 26%, rgba(243, 252, 255, 0) 27%),
            linear-gradient(90deg, rgb(255 199 83) 0%, rgb(255 140 41 / 99%) 42%, rgb(240 164 22 / 96%) 100%) !important;
        color: #f8fcff !important;
        box-shadow: inset 0 1px 0 rgba(243, 252, 255, .3), inset 0 -.05rem .12rem rgba(8, 46, 96, .18) !important;
    }

    .content .pages .func_btns > div,
    .popup .pages .func_btns > div {
        background:
            linear-gradient(180deg, rgba(239, 251, 255, .18) 0%, rgba(239, 251, 255, .06) 24%, rgba(239, 251, 255, 0) 25%),
            linear-gradient(90deg, rgba(24, 105, 206, .92) 0%, rgba(14, 74, 153, .94) 48%, rgba(8, 39, 82, .96) 100%) !important;
        color: #f5fbff !important;
        border: 1px solid rgba(120, 210, 255, .22) !important;
    }

    .content .pages .func_btns > div:first-child,
    .popup .pages .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba(243, 252, 255, .24) 0%, rgba(243, 252, 255, .08) 26%, rgba(243, 252, 255, 0) 27%),
            linear-gradient(90deg, rgb(255 199 83) 0%, rgb(255 140 41 / 99%) 42%, rgb(240 164 22 / 96%) 100%) !important;
        color: #f8fcff !important;
    }

    &.mobile {
        .user_info .user_box {
            background:
                linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
            border-color: rgba(255,255,0, .24) !important;
            box-shadow: inset 0 1px 0 rgba(232, 248, 255, .08), 0 .08rem .18rem rgba(4, 16, 34, .16) !important;
        }

        .user_info .user_box .icon_logout {
            background:
                linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
            border-color: rgba(255,255,0, .28) !important;
            box-shadow: inset 0 1px 0 rgba(239, 251, 255, .16), 0 .05rem .12rem rgba(4, 16, 34, .12) !important;
        }

        .user_info .user_box > div .phone,
        .user_info .user_box > div > div,
        .money_box .header,
        .money_box .money_wrap > div:first-child,
        .contaItem .contaTitleLine,
        .menus .menus-item {
            color: #ffffff !important;
        }

        .vip_box,
        .money_box,
        .contaItem,
        .menus {
            background:
                linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
            border-color: rgba(255,255,0, .24) !important;
            box-shadow: inset 0 1px 0 rgba(232, 248, 255, .08), 0 .08rem .18rem rgba(4, 16, 34, .16) !important;
        }

        .vip_box .next-vip {
            background: linear-gradient(90deg, transparent, rgba(255, 177, 76, .82)) !important;
        }

        .vip_box .vip_img .vip_level,
        .vip_box .vip_info .vip_progress .rate span,
        .contaItem .spreadLine .spreadAmount {
            color: #ffe38f !important;
        }

        .money_box .money_wrap > div:last-child,
        .contaItem .spreadLine .spreadName,
        .menus {
            color: #fffae1 !important;
        }

        .menus .menus-item,
        .contaItem .line {
            border-bottom-color: rgba(120, 210, 255, .16) !important;
        }
    }

    .content .pages .user_info .user_box .icon_logout,
    .popup .pages .user_info .user_box .icon_logout,
    .content .pages .func_btns > div,
    .popup .pages .func_btns > div {
        background:
            linear-gradient(180deg, rgba(239, 251, 255, .18) 0%, rgba(239, 251, 255, .06) 24%, rgba(239, 251, 255, 0) 25%),
            linear-gradient(90deg, rgba(24, 105, 206, .92) 0%, rgba(14, 74, 153, .94) 48%, rgba(8, 39, 82, .96) 100%) !important;
        color: #f5fbff !important;
        border: 1px solid rgba(120, 210, 255, .22) !important;
        box-shadow: inset 0 1px 0 rgba(239, 251, 255, .18), 0 .05rem .12rem rgba(4, 16, 34, .12) !important;
    }

    .content .pages .func_btns > div:first-child,
    .popup .pages .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba(243, 252, 255, .24) 0%, rgba(243, 252, 255, .08) 26%, rgba(243, 252, 255, 0) 27%),
            linear-gradient(90deg, rgb(255 199 83) 0%, rgb(255 140 41 / 99%) 42%, rgb(240 164 22 / 96%) 100%) !important;
        color: #f8fcff !important;
        border-color: rgba(142, 227, 255, .42) !important;
    }

    .content .pages .func_btns > div:last-child,
    .popup .pages .func_btns > div:last-child {
        background:
            linear-gradient(180deg, rgba(235, 248, 255, .12) 0%, rgba(235, 248, 255, .04) 24%, rgba(235, 248, 255, 0) 25%),
            linear-gradient(90deg, rgba(32, 122, 223, .94) 0%, rgba(17, 86, 176, .96) 48%, rgba(8, 45, 99, .98) 100%) !important;
        color: #ffffff !important;
        border: 1px solid rgba(118, 208, 255, .26) !important;
        box-shadow: inset 0 1px 0 rgba(239, 251, 255, .16), 0 .05rem .12rem rgba(4, 16, 34, .14) !important;
    }

    .content .pages .money_box,
    .content .pages .contaItem,
    .content .pages .menus,
    .popup .pages .money_box,
    .popup .pages .contaItem,
    .popup .pages .menus {
        background:
            linear-gradient(180deg, rgba(93, 43, 8, 0.98) 0%, rgba(50, 20, 3, 0.99) 100%) !important;
        border-color: rgba(255,255,0, .28) !important;
        box-shadow: inset 0 1px 0 rgba(232, 248, 255, .1), 0 .08rem .18rem rgba(4, 16, 34, .18) !important;
    }
    .user_info .user_box,
    .vip_box,
    .money_box,
    .contaItem,
    .menus {
        background:
            radial-gradient(circle at 14% 0, rgba(255, 210, 74, .14) 0, rgba(255, 210, 74, 0) 34%),
            linear-gradient(180deg, rgba(106, 49, 8, .98) 0%, rgba(43, 15, 1, 1) 100%) !important;
        border-color: rgba(255, 198, 83, .3) !important;
        box-shadow: inset 0 1px 0 rgba(255, 242, 193, .1), 0 .08rem .18rem rgba(25, 7, 0, .22) !important;
    }

    background:
        radial-gradient(circle at top center, rgba(255, 190, 54, .16) 0%, rgba(255, 190, 54, 0) 42%),
        linear-gradient(180deg, rgba(53, 19, 1, .98) 0%, rgba(25, 8, 0, 1) 100%) !important;

    .user_info {
        background: transparent !important;
        box-shadow: none !important;
    }

    &.mobile {
        background:
            radial-gradient(circle at top center, rgba(255, 190, 54, .16) 0%, rgba(255, 190, 54, 0) 42%),
            linear-gradient(180deg, rgba(53, 19, 1, .98) 0%, rgba(25, 8, 0, 1) 100%) !important;

        .user_info .user_box,
        .vip_box,
        .contaItem,
        .menus {
            background:
                radial-gradient(circle at 14% 0, rgba(255, 210, 74, .14) 0, rgba(255, 210, 74, 0) 34%),
                linear-gradient(180deg, rgba(106, 49, 8, .98) 0%, rgba(43, 15, 1, 1) 100%) !important;
            border-color: rgba(255, 198, 83, .3) !important;
            box-shadow: inset 0 1px 0 rgba(255, 242, 193, .1), 0 .08rem .18rem rgba(25, 7, 0, .22) !important;
        }

        .money_box .func_btns > div {
            background:
                linear-gradient(180deg, rgba(255, 242, 193, .14) 0%, rgba(255, 242, 193, 0) 26%),
                linear-gradient(180deg, #7d3b08 0%, #3f1902 100%) !important;
            color: $font-color !important;
            border-color: rgba(255, 198, 83, .3) !important;
        }

        .money_box .func_btns > div:first-child {
            background:
                linear-gradient(180deg, rgba(255, 252, 220, .24) 0%, rgba(255, 252, 220, 0) 26%),
                $bg-btn-color !important;
            color: $font-btn-color !important;
            border-color: rgba(255, 225, 128, .56) !important;
        }
    }

    .vip_box .next-vip {
        background: linear-gradient(90deg, transparent, rgba(255, 151, 20, .84)) !important;
    }

    .vip_box .vip_img .vip_level,
    .vip_box .vip_info .vip_progress .rate span,
    .contaItem .spreadLine .spreadAmount {
        color: $font-theme-color !important;
    }

    .money_box .money_wrap > div:last-child,
    .contaItem .spreadLine .spreadName,
    .menus,
    .logout {
        color: $font-sub-color !important;
    }

    .menus .menus-item,
    .contaItem .line {
        border-color: rgba(255, 198, 83, .2) !important;
    }

    .func_btns > div,
    .user_info .user_box .icon_logout {
        background:
            linear-gradient(180deg, rgba(255, 242, 193, .14) 0%, rgba(255, 242, 193, 0) 26%),
            linear-gradient(180deg, #7d3b08 0%, #3f1902 100%) !important;
        color: $font-color !important;
        border-color: rgba(255, 198, 83, .3) !important;
        box-shadow: inset 0 1px 0 rgba(255, 242, 193, .14), 0 .05rem .12rem rgba(25, 7, 0, .2) !important;
    }

    .func_btns > div:first-child {
        background:
            linear-gradient(180deg, rgba(255, 252, 220, .24) 0%, rgba(255, 252, 220, 0) 26%),
            $bg-btn-color !important;
        color: $font-btn-color !important;
        border-color: rgba(255, 225, 128, .56) !important;
    }

    #person-deposit-btn {
        background:
            linear-gradient(180deg, rgba(255, 252, 220, .2) 0%, rgba(255, 252, 220, 0) 28%),
            linear-gradient(90deg, #ffe16a 0%, #ffbd28 52%, #f28a00 100%) !important;
        background-color: #ffbd28 !important;
        background-image:
            linear-gradient(180deg, rgba(255, 252, 220, .2) 0%, rgba(255, 252, 220, 0) 28%),
            linear-gradient(90deg, #ffe16a 0%, #ffbd28 52%, #f28a00 100%) !important;
        color: #3b1700 !important;
        border: 1px solid rgba(255, 225, 128, .56) !important;
        box-shadow: inset 0 1px 0 rgba(255, 249, 207, .28), 0 .06rem .16rem rgba(55, 18, 0, .24) !important;
    }

    #person-withdraw-btn {
        background:
            linear-gradient(180deg, rgba(255, 238, 189, .16) 0%, rgba(255, 238, 189, 0) 28%),
            linear-gradient(90deg, #ffad19 0%, #f47700 56%, #c84700 100%) !important;
        background-color: #f47700 !important;
        background-image:
            linear-gradient(180deg, rgba(255, 238, 189, .16) 0%, rgba(255, 238, 189, 0) 28%),
            linear-gradient(90deg, #ffad19 0%, #f47700 56%, #c84700 100%) !important;
        color: #3b1700 !important;
        border: 1px solid rgba(255, 198, 83, .5) !important;
        box-shadow: inset 0 1px 0 rgba(255, 249, 207, .22), 0 .06rem .16rem rgba(55, 18, 0, .24) !important;
    }

    &.pages .menus .menus-item {
        background: transparent !important;
        border: 0 !important;
        border-bottom: 1px solid rgba(255, 198, 83, .22) !important;
        box-shadow: none !important;
        border-radius: .2rem;
        margin-top: .1rem;
    }

    &.pages .menus .menus-item:last-child {
        border-bottom: 0 !important;
    }
}</style>
